export enum FiltersFormsKeysEnum {
  SO_LIST = 'SO_LIST',
}
